// extracted by mini-css-extract-plugin
export default {"root":"_0swsNAr","inner":"_1sEyn8T","inner__before":"qNhmjdE","inner__content":"_1A-4vVo","inner__after":"JxRmdN6"};